<script lang="ts" setup>
import type { LinkGroupTypeFragment } from '~~layers/.nuxt/graphql-operations'

import { AppLink } from '#components'

defineProps<{
  menu: LinkGroupTypeFragment
}>()

const { loadIcon } = useDynamicIcons()

const getElement = (to: string | null | undefined) => {
  return to ? AppLink : 'span'
}
</script>

<template>
  <ul
    v-if="menu.Items.length"
    class="footer-menu"
  >
    <li
      v-for="(group, index) in menu.Items"
      :key="index"
      class="footer-menu__item"
    >
      <div
        v-if="group.Description"
        class="footer-menu__description"
      >
        {{ group.Description }}
      </div>
      <component
        :is="getElement(group.Link)"
        v-if="group.Name"
        :to="group.Link"
        class="footer-menu__link"
      >
        <NuxtIcon
          v-if="group.Icon"
          :name="loadIcon(group.Icon)"
        />
        {{ group.Name }}
      </component>
    </li>
  </ul>
</template>

<style>
@import url("~layers/components/Footer/Menu.css");
</style>
